export default "__VITE_ASSET__4eG8i4t4__"